import React, { useState } from "react"
import { Link } from "react-router-dom"
import { Button, Container } from "reactstrap"

// import images
import logodarkImg from "../../assets/images/pula-logo.svg"
import logosmImg from "../../assets/images/pula-logo.svg"
const navItems = [
  {
    label: "DIRECTORY",
    to: "https://pulapuneladies.com/directory/",
    external: true,
  },
  {
    label: "EVENTS",
    to: "/",
  },
  {
    label: "WRITERS CLUB",
    to: "https://pulapuneladies.com/writers-club/stories/",
    external: true,
  },
]
const EventNavbar = () => {
  const [isMobileMenuOpen, setIsMenuOpened] = useState(false)

  const toggleMobileMenu = () => setIsMenuOpened(!isMobileMenuOpen)
  const closeMenu = () => setIsMenuOpened(false)

  const renderNavLinks = (isMobile = false) =>
    navItems.map((item, index) => (
      <li key={index} className={isMobile ? "mb-3" : ""}>
        <Link
          className="nav-link"
          to={item.to}
          target={item.external ? "_blank" : "_self"}
          onClick={isMobile ? closeMenu : undefined}
        >
          {item.label}
        </Link>
      </li>
    ))
  return (
    <>
      <header className="py-2 header-sticky">
        <Container fluid={false}>
          <div className="navbar-header">
            <div className="d-flex">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logosmImg} alt="Pula Logo" />
                </span>
                <span className="logo-lg">
                  <img src={logodarkImg} alt="Pula Logo" />
                </span>
              </Link>
            </div>
            <ul className="d-none wg-navbar d-md-flex align-items-center list-unstyled gap-4 mb-0">
              {renderNavLinks()}
            </ul>
            <div className="d-none d-md-block">
              <Link
                to="https://pulapuneladies.com/pvs-registration/"
                target="_blank"
              >
                <Button className="bg-primary text-white">GET VERIFIED</Button>
              </Link>
            </div>

            <div className="d-md-none">
              <button className="btn" onClick={toggleMobileMenu}>
                <i className="ti-menu font-size-20"></i>
              </button>
            </div>
          </div>
        </Container>
        <div
          className={`eventnav-mob  ${
            isMobileMenuOpen ? "eTranslate-x-0" : "eTranslate-x-100"
          }`}
        >
          <div className="d-flex justify-content-end mb-4">
            <button className="btn" onClick={closeMenu}>
              <i className="dripicons-cross font-size-20" />
            </button>
          </div>
          <ul className="list-unstyled">{renderNavLinks(true)}</ul>
          <Link
            to="https://pulapuneladies.com/pvs-registration/"
            target="_blank"
            onClick={closeMenu}
          >
            <Button className="bg-primary text-white w-100 mt-3">
              GET VERIFIED
            </Button>
          </Link>
        </div>
      </header>
    </>
  )
}

export default EventNavbar
